import { Estoque } from './estoque';
import { Fornecedor } from './fornecedor';
import { Marca } from './marca';
import { Garantia } from '../enums/garantia';

export class Produto {
  id:  number | null = null;
  ativo?: boolean | null = true;
  nome: string = '';
  preco: number = 0;
  precoCompra: number = 0;
  precoAtacado: number = 0;
  precoFabrica: number = 0;
  codigoBarras: string = '';
  serialImei: string = '';
  garantia: Garantia | null = null;
  marca: Marca | null = null;
  fornecedor: Fornecedor | null = null;
  estoque: Estoque | null = null;
  dataCadastro: Date | null = null;
  dataUltimaModificacao: Date | null = null;
}
